import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { take, map, retry, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { DownloadFileUtil } from '../../util/download-file-util';

const CONTROLLER = 'EnvelopeFile';

@Injectable({
  providedIn: 'root'
})
export class FileEnvelopeService {



  constructor(private http: HttpClient) {
  }

  public insert(file: any, suffixBucketName: any) {
    if (suffixBucketName == undefined) {
      return this.http.post(CONTROLLER, file).pipe(
        take(1),
        retry(1),
        catchError(this.handleError));
    } else {
      return this.http.post(CONTROLLER + '?suffixBucketName=' + suffixBucketName, file).pipe(
        take(1),
        retry(1),
        catchError(this.handleError));
    }
  }

  public convertToPdf(file: any) {
    return this.http.post(CONTROLLER.concat('/convert-doc'), file).pipe(
      take(1),
      retry(1),
      catchError(this.handleError));
  }

  public deleteFiles(envelopeFileIds: number[]) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      body: envelopeFileIds,
    };

    return this.http.delete(CONTROLLER, options).pipe(
      map(x => x),
      take(1),
      retry(1),
      catchError(this.handleError));
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Erro ocorreu no lado do client
      errorMessage = error.error.message;
    } else {
      // Erro ocorreu no lado do servidor
      errorMessage = `Código do erro: ${error.status}, ` + `menssagem: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }

  downloadPDF(envelopeId: any): Promise<any> {
    return this.getPDF(envelopeId).then((data) => {
      DownloadFileUtil.downloadFile(data);
    });
  }

  getHeaders() {
    const headerOptions = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/pdf'
    });
    const requestOptions = {
      headers: headerOptions,
      responseType: 'arraybuffer' as 'json', observe: 'response' as any
    };
    return requestOptions;
  }

  getPDF(envelopeIdOrAccessKey: any): Promise<any> {
    const requestOptions = this.getHeaders();
    return this.http.get(`${CONTROLLER}/${envelopeIdOrAccessKey}`, requestOptions)
      .pipe(
        take(1),
        map((data: any) => data),
        catchError(this.handleError)
      ).toPromise();
  }

  getPDFEnvelopeFile(envelopeIdOrAccessKey: any, envelopeFileId: any): Promise<any> {
    const requestOptions = this.getHeaders();
    return this.http.get(`${CONTROLLER}/${envelopeIdOrAccessKey}/${envelopeFileId}`, requestOptions)
      .pipe(
        take(1),
        map((data: any) => data),
        catchError(this.handleError)
      ).toPromise();
  }

  downloadSignedPDF(envelopeId: any): Promise<any> {
    return this.getSignedPDF(envelopeId).then((data) => {
      DownloadFileUtil.downloadFile(data);
    });
  }

  downloadPrintingPDF(envelopeId: any, withStamp: boolean): Promise<any> {
    return this.getPrintingPDF(envelopeId, withStamp).then((data) => {
      DownloadFileUtil.downloadFile(data);
    });
  }

  getSignedPDF(envelopeId: any): Promise<any> {
    const requestOptions = this.getHeaders();
    return this.http.get(`${CONTROLLER.concat('/signed')}/${envelopeId}`, requestOptions)
      .pipe(
        take(1),
        map((data: any) => data),
        catchError(this.handleError)
      ).toPromise();
  }

  getPrintingPDF(envelopeId: any, withStamp: boolean): Promise<any> {
    const requestOptions = this.getHeaders();
    return this.http.get(`${CONTROLLER.concat('/report')}/${envelopeId}/${withStamp}`, requestOptions)
      .pipe(
        take(1),
        map((data: any) => data),
        catchError(this.handleError)
      ).toPromise();
  }
}
